<template>
  <NuxtLayout :name="layout.type">
    <NuxtPage />
    <template v-if="hideWhatsApp" #whats-app>
      <div></div>
    </template>
  </NuxtLayout>
</template>
<script setup lang="ts">
import type { LayoutInfo } from "#custom-types";

const runtimeConfig = useRuntimeConfig();

const layout = ref<MaybeRef>(runtimeConfig.public.layout as LayoutInfo);

const route = useRoute();

const hideWhatsApp = computed(
  () => false
  // (route.name?.toString().includes("things-to-do") &&
  //   !route.params.productSlug) ||
  // route.name?.toString().includes("categorySlug")
);
</script>
